import React from "react";
import { useController, useFormContext } from "react-hook-form";
import PropTypes from "prop-types";

import { EmailInput } from "../../../AddUserModal/components/NewUserInfoPage/components";

export function ControlledEmailInput({ name, defaultValue, ...props }) {
  const { setError, clearErrors } = useFormContext();
  const {
    field,
    fieldState: { error },
  } = useController({ name, defaultValue });

  return (
    <EmailInput
      name={name}
      onChange={field.onChange}
      onBlur={field.onBlur}
      value={field.value}
      error={Boolean(error?.message)}
      setError={setError}
      clearErrors={clearErrors}
      onVerifying={() => {}}
      {...props}
    />
  );
}

ControlledEmailInput.propTypes = {
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.string,
};

ControlledEmailInput.defaultProps = {
  defaultValue: "",
};

export default ControlledEmailInput;
